import { cn } from '../lib/cn.js';

export interface SkeletonProps {
  /** CSS width (px number or string). Default 100%. */
  width?: number | string;
  /** CSS height. Default 12px. */
  height?: number | string;
  className?: string;
}

/** Static placeholder block (--card). No shimmer: motion is reserved for pulse-red. */
export function Skeleton({ width = '100%', height = 12, className }: SkeletonProps) {
  return <span aria-hidden className={cn('block rounded-sm bg-card', className)} style={{ width, height }} />;
}

export interface SkeletonRowsProps {
  rows?: number;
  /** Column width fractions for each row, e.g. [0.3, 0.5, 0.2]. */
  columns?: number[];
  className?: string;
  /** Accessible loading text. */
  label?: string;
}

/** Loading rows for tables and lists: 12.5px rows separated by --hair rules. */
export function SkeletonRows({ rows = 5, columns = [0.28, 0.44, 0.16], className, label = 'Loading' }: SkeletonRowsProps) {
  return (
    <div role="status" aria-label={label} aria-busy className={cn('flex flex-col', className)}>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex items-center gap-4 border-b border-hair px-4 py-2.5">
          {columns.map((fraction, j) => (
            <Skeleton key={j} width={`${Math.round(fraction * 100)}%`} height={10} />
          ))}
        </div>
      ))}
    </div>
  );
}
